// extracted by mini-css-extract-plugin
export default {"note":"AppointmentSummaryNote_note__H1gbI","date-txt":"AppointmentSummaryNote_date-txt__CSk7i"};